export const CASE_STUDIES = {
  janani: {
    slug: "janani",
    name: "Janani & Bachpan",
    tag: "AI App · Healthcare",
    url: "https://jananibachpan.com",
    timeline: "1 week",
    hero:
      "https://images.pexels.com/photos/17195067/pexels-photo-17195067.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    summary:
      "An AI companion for pregnancy & motherhood — multilingual, empathetic and always available, built for Indian mothers.",
    challenge:
      "New and expecting mothers needed trustworthy, culturally-aware guidance in their own language, available 24/7 — without the cost and friction of constant clinic visits.",
    solution:
      "We built a full-stack AI companion that answers pregnancy and parenting questions in English, Hindi and Telugu, with secure authentication, conversation history and a warm, reassuring experience tailored for Indian mothers.",
    results: [
      "Shipped a production-ready AI app in a single week",
      "Multilingual support (English / हिन्दी / తెలుగు)",
      "Secure login and personalized guidance",
      "Mobile-first, deploy-ready experience",
    ],
    stack: ["React", "FastAPI", "MongoDB", "LLM / RAG", "Auth", "Multi-language"],
  },
  "ace-ai": {
    slug: "ace-ai",
    name: "ACE AI Apps",
    tag: "AI Agents · Productivity",
    url: null,
    timeline: "1 week",
    hero:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    summary:
      "A suite of domain-specific AI agents that automate research, support and operations for growing teams.",
    challenge:
      "Teams were drowning in repetitive research, triage and support tasks that ate into the hours they needed for real growth work.",
    solution:
      "We designed autonomous AI agents that plug into existing workflows — researching, drafting, triaging and routing — with a clean control surface so humans stay in the loop where it matters.",
    results: [
      "Automated multi-step research & support workflows",
      "Autonomous agents with human-in-the-loop controls",
      "Lean build, shipped in a week",
      "Easily extendable to new domains",
    ],
    stack: ["React", "FastAPI", "MongoDB", "LLM Agents", "Vector DB", "Realtime"],
  },
};
